exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".body-2c185d7c{width:350px}.content-064f34cd{overflow-x:hidden}.header-7faab455{text-align:left;background:#6982FF;color:#FFF;font-weight:500;padding-top:10px;padding-bottom:10px;padding-left:15px;padding-right:15px;font-size:15px;width:350px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-radius:4px 4px 0 0}.previewImgContainer-5f54a659{height:200px;width:350px}.metrics-7af04feb{display:flex;position:relative;flex-wrap:wrap;text-align:left;padding-left:15px;padding-right:15px;padding-top:10px;padding-bottom:15px}.metric-51ed4483{flex:0 0 auto;margin-right:30px}.metric-51ed4483 .value-f4d5ac4c{font-weight:bold;font-size:14px;margin-bottom:0px}.metric-51ed4483 .label-32fd5505{font-size:13px;line-height:13px}\n", ""]);

// Exports
exports.locals = {
	"body": "body-2c185d7c",
	"content": "content-064f34cd",
	"header": "header-7faab455",
	"previewImgContainer": "previewImgContainer-5f54a659",
	"metrics": "metrics-7af04feb",
	"metric": "metric-51ed4483",
	"value": "value-f4d5ac4c",
	"label": "label-32fd5505"
};